import { render, staticRenderFns } from "./meetingStaff.vue?vue&type=template&id=6961b4b7&scoped=true"
import script from "./meetingStaff.vue?vue&type=script&lang=js"
export * from "./meetingStaff.vue?vue&type=script&lang=js"
import style0 from "./meetingStaff.vue?vue&type=style&index=0&id=6961b4b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961b4b7",
  null
  
)

export default component.exports